import * as Sentry from '@sentry/react';

import { history } from 'router/history';
import { APP_ENV } from 'constants/env';

if (APP_ENV === 'production') {
  Sentry.init({
    dsn: 'https://b9017b5a43ae8c3eb11d57e026b4f363@o1329521.ingest.us.sentry.io/4509723913158656',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.reactRouterV5BrowserTracingIntegration({ history }),
      Sentry.replayIntegration({
        maskAllText: false,
      }),
    ],
    // Session Replay
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    // Tracing
    tracesSampleRate: 1.0,
  });
}

export default Sentry;
